@let blok = block();
<tr [style.grid-template-columns]="columnsStyle()" class="grid gap-4">
    <td class="hidden lg:flex items-center text-lg font-bold p-4">
        {{ blok.title }}
    </td>
    @for (column of blok.columns; track column._uid) {
        <td app-tariff-table-footer-column
            [block]="column" class="hidden lg:block"
            [columns]="columns()">
        </td>
    }

    @if (blok.mobileAction?.length) {
        <td class="col-span-3 lg:hidden">
            <s1-button [block]="blok.mobileAction![0]"
                       class="w-full" />
        </td>
    }
</tr>
